export default {
    indexPaymentTypeSettings:   { method: 'get',    url: 'payment_type_settings' },
    createPaymentTypeSetting:   { method: 'post',   url: 'payment_type_settings'},
    updatePaymentTypeSetting:   { method: 'put',    url: 'payment_type_settings/{id}'},
    destroyPaymentTypeSetting:  { method: 'delete', url: 'payment_type_settings/{id}'},
}